import styled from '@emotion/styled';
import React, { useCallback } from 'react';
import Icon from '../../component-library/Icon';
import HeaderWrapper from '../../component-library/navigation/NavBar/HeaderWrapper';
import MobileSubmenu from '../../component-library/navigation/NavBar/LinksGroup/MobileSubmenu';
import MobileNavBar from '../../component-library/navigation/NavBar/MobileNavBar';
import NavBarContainer from '../../component-library/navigation/NavBar/NavBarContainer';
import { Home, Props, useNavBar } from './common';

const BurgerNavigation = styled.button`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
`;

const HamburgerIcon = styled(Icon)`
  cursor: pointer;
`;

const ContentfulMobileBar = ({ navigationBar, initiallyTransparent }: Props) => {
  const {
    submenu,
    clearSubmenu,
    setHovered,
    linkGroups,
    navButton,
    handleNavItemSelected,
    mobileBottomLinks,
    isMenuOpened,
    setIsMenuOpened,
  } = useNavBar({ navigationBar });

  const mobileClickOutSide = useCallback(
    (event) => {
      event.stopPropagation();
      if (!event?.target?.closest('#navbar')) {
        setIsMenuOpened(false);
      }
    },
    [setIsMenuOpened],
  );

  const toggleMobileMenu = useCallback(() => {
    if (isMenuOpened) {
      clearSubmenu();
    }
    setIsMenuOpened((o) => !o);
  }, [isMenuOpened, setIsMenuOpened, clearSubmenu]);

  return (
    <HeaderWrapper
      initiallyTransparent={initiallyTransparent}
      overrideTransparent={isMenuOpened}
      hideNavBar={clearSubmenu}
      preventHideNavBar={isMenuOpened}
      onHover={setHovered}
    >
      {({ textColor }) => (
        <>
          <NavBarContainer>
            <Home textColor={textColor} handleNavItemClick={handleNavItemSelected} />
            <BurgerNavigation onClick={toggleMobileMenu} aria-label={'menu'}>
              {isMenuOpened ? (
                <HamburgerIcon name="x-cross" stroke={textColor} fill={textColor} size={20} />
              ) : (
                <HamburgerIcon name="hamburger" stroke={textColor} fill={textColor} size={22} />
              )}
            </BurgerNavigation>
          </NavBarContainer>
          <MobileNavBar
            isOpened={isMenuOpened}
            linkGroups={linkGroups}
            handleNavItemClick={handleNavItemSelected}
            button={navButton}
            bottomLinks={mobileBottomLinks}
            clickOutside={mobileClickOutSide}
          />
          <MobileSubmenu
            isOpened={isMenuOpened}
            submenu={submenu}
            goBack={clearSubmenu}
            clickOutside={mobileClickOutSide}
            onLinkedClicked={toggleMobileMenu}
          />
        </>
      )}
    </HeaderWrapper>
  );
};

export default ContentfulMobileBar;
